<template>
  <default-modal
    ref="box"
    :title="title"
    :modalWidth="600"
    :confirmTxt="`保存`"
    @confirm="confirm"
  >
    <div class="modal-body">
      <div>
        <div class="row">
          <span class="left">路由品牌：</span>
          <select
            name="remoteType"
            class="first"
            v-model="tradeMark"
          >
            <option
              v-for="(item, index) in routeMarkList"
              :value="item.trademark"
              :key="index"
              v-text="item.remotingName"
            ></option>
          </select>
        </div>
        <!-- 非多个网吧操作 -->
        <div
          class="row"
          v-show="!operateAllState"
        >
          <span class="left">获取方式：</span>
          <select
            name="httpWay"
            v-model="scheme"
            style="margin-right:10px;"
          >
            <option value="http">http</option>
            <option value="https">https</option>
          </select>
          <select
            name="status"
            v-model="status"
          >
            <option value="0">手动填写IP</option>
            <option value="1">自动获取IP</option>
          </select>
        </div>
        <!-- 多个网吧操作 -->
        <div
          class="row"
          v-show="operateAllState"
        >
          <span class="left">获取方式：</span>
          <select
            name="httpWay"
            v-model="scheme"
            style="margin-right:10px;"
          >
            <option value="http">http</option>
            <option value="https">https</option>
          </select>
          <select name="status">
            <option value="1">自动获取IP</option>
          </select>
        </div>
        <div class="row">
          <span
            v-show="status == 0"
            class="left"
          >链接地址：</span>
          <span
            v-show="status == 1"
            class="left"
          >端口：</span>
          <input
            class="default-input"
            style="width:150px;"
            type="text"
            v-show="status == 0"
            v-model="ip"
          />
          <span
            v-show="status == 0"
            style="margin-left:10px;"
          >端口：</span>
          <input
            type="text"
            style="width:112px;"
            class="default-input"
            v-model="port"
          />
        </div>
        <div
          class="row"
          v-show="status == 0 && !operateAllState"
        >
          <span class="left">完整地址：</span>
          <span v-text="scheme + '://' + ip + ':' + port"></span>
        </div>
        <div class="row">
          <span class="left">路由账号：</span>
          <input
            type="text"
            class="default-input"
            v-model="routerPassAccount"
            placeholder="请填写路由器本地登录账号"
          />
        </div>
        <!-- 添加时 -->
        <div
          class="row"
          v-show="type == 0"
        >
          <span class="left">路由密码：</span>
          <input
            type="password"
            class="default-input"
            v-model="routerPassPwd"
            placeholder="请填写路由器本地登录密码"
          />
        </div>
        <!-- 修改时 -->
        <div
          class="row"
          v-show="type == 1"
        >
          <span class="left">路由密码：</span>
          <input
            type="password"
            style="width:180px;border:none;"
            v-show="pwdEditState == 0"
            class="default-input"
            value="********"
            readonly
            placeholder="请填写路由器本地登录密码"
          />
          <input
            type="password"
            style="width:180px;"
            v-show="pwdEditState == 1"
            class="default-input"
            v-model="routerPassPwd"
            placeholder="请填写路由器本地登录密码"
          />
          <a
            href="#"
            v-show="pwdEditState == 0"
            @click.prevent="
                            routerPassPwd = '';
                            pwdEditState = 1;
                        "
            style="margin-left:10px;color:#0099cc"
          >修改</a>
          <a
            href="#"
            v-show="pwdEditState == 1"
            @click.prevent="
                            routerPassPwd = '';
                            pwdEditState = 0;
                        "
            style="margin-left:10px;color:#0099cc"
          >取消</a>
        </div>
        <div class="row">
          <span class="left">备注信息：</span>
          <input
            type="text"
            class="default-input"
            v-model="remark"
            placeholder="可备注路由器线路等信息"
          />
        </div>
      </div>
    </div>
  </default-modal>
</template>
<script>
// 头部tag内容
// import HeaderTag from "_c/tagTitle/headerTag";
import DefaultModal from "_c/modals/defaultModal";

import {
  // getBarRemoteInfo,
  // updateBarRemoteInfo,
  queryTradeMarkList,
  addRouter,
  updateRouter
} from "@/requests/bar";
export default {
  components: {
    DefaultModal
  },
  data() {
    return {
      type: 0, //0:添加,1:修改
      barId: "",
      routeMarkList: [
        // {
        //     trademark,
        //     remotingName
        // }
      ],
      tradeMark: "",
      scheme: "http",
      status: 0,
      ip: "",
      port: "",
      routerPassAccount: "",
      routerPassPwd: "",
      pwdEditState: 0,
      remark: "",
      routerId: "",
      operateAllState: false, //是否多个操作
      successFn: ""
    };
  },
  computed: {
    /* eslint-disable */
    title() {
      if (this.type == 0) {
        return "添加路由远程";
      } else if (this.type == 1) {
        return "修改路由远程";
      }
    }
  },
  mounted() {
    window.$modal.setRouterRemoteModal = {};
    window.$modal.setRouterRemoteModal.show = (
      {
        barId,
        tradeMarkId,
        account,
        scheme,
        status,
        ip,
        port,
        remark,
        routerId
      },
      type,
      operateAllState
    ) => {
      // 初始化密码显示
      this.routerPassPwd = "";
      this.pwdEditState = 0;
      this.tradeMark = "";
      this.routerPassAccount = "";
      this.scheme = "";
      this.status = "";
      this.ip = "";
      this.port = "";
      this.remark = "";
      this.routerId = "";
      // 是否为批量操作
      this.operateAllState = operateAllState ? true : false;
      if (operateAllState) {
        this.operateAllState = true;
        this.status = 1;
      } else {
        this.operateAllState = false;
      }
      this.type = type ? type : 0;
      this.barId = barId;
      // 修改路由
      if (this.type == 1) {
        this.tradeMark = tradeMarkId;
        this.routerPassAccount = account;
        this.scheme = scheme;
        this.status = status;
        this.ip = ip;
        this.port = port;
        this.remark = remark;
        this.routerId = routerId;
      }
      return new Promise(resolve => {
        this.init(() => {
          resolve(true);
        });
      });
    };
  },
  watch: {
    'ip'() {
      if (this.ip.indexOf('http://') === 0) {
        this.ip = this.ip.substring(7, this.ip.length)
      }
      if (this.ip.indexOf('https://') === 0) {
        this.ip = this.ip.substring(8, this.ip.length)
      }
      console.log(this.ip.indexOf('/'))
      if (this.ip.indexOf('/') > 0) {
        this.ip = this.ip.substring(0, this.ip.indexOf('/'))
      }
    }
  },
  methods: {
    // 初始化信息
    async init(fn) {
      this.$refs.box.clearWrong();
      await this.queryTradeMarkList();
      this.$refs.box.show();
      this.successFn = fn;
    },
    async confirm() {
      this.$refs.box.clearWrong();
      let vdt;
      let res;
      // 添加
      let autoGetIP = this.status == 1 ? true : false;
      if (this.operateAllState) {
        autoGetIP = true;
      }
      // ip校验
      if (!autoGetIP) {
        vdt = this.$validateCenter.ip(this.ip);
        if (!vdt.res) {
          return this.$refs.box.setWrong(vdt.msg);
        }
      }
      // 端口校验
      vdt = this.$validateCenter.port(this.port);
      if (!vdt.res) {
        return this.$refs.box.setWrong(vdt.msg);
      }
      if (this.routerPassAccount.trim() === "") {
        return this.$refs.box.setWrong("请输入路由账号");
      }
      if (this.pwdEditState == 1 && this.routerPassPwd.trim() === "") {
        return this.$refs.box.setWrong("请输入路由密码");
      }
      if (this.type == 0) {
        let newIp
        if (this.ip.indexOf('http://' == 0)) {
          //console.log(222)
        } else {
          //console.log(223)
        }
        res = await addRouter({
          barId: this.barId,
          tradeMark: this.tradeMark,
          autoGetIP,
          scheme: this.scheme,
          ip: this.ip,
          port: this.port,
          routerPassAccount: this.routerPassAccount,
          routerPassPwd: this.routerPassPwd,
          remark: this.remark
        });
      } else if (this.type == 1) {
        // 修改
        res = await updateRouter({
          barId: this.barId,
          tradeMark: this.tradeMark,
          autoGetIP,
          scheme: this.scheme,
          ip: this.ip,
          port: this.port,
          routerPassAccount: this.routerPassAccount,
          routerPassPwd: this.routerPassPwd,
          remark: this.remark,
          routerId: this.routerId
        });
      }
      if (res.code == 200) {
        this.$refs.box.hide();
        this.successFn();
      } else {
        this.$refs.box.setWrong(res.msg);
      }
    },
    async queryTradeMarkList() {
      this.routeMarkList = await queryTradeMarkList();
      if (this.type == 0) {
        if (this.routeMarkList.length > 0) {
          this.tradeMark = this.routeMarkList[0].trademark;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "_style/_color.scss";
.modal-body {
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: left;
  .row {
    height: 31px;
    line-height: 31px;
    margin-top: 10px;
    overflow: hidden;
    margin-left: 20px;
    select {
      width: 150px;
      height: 30px;
      border: 1px solid rgba(230, 230, 230, 1);
      outline: none;
    }
    input {
      width: 310px;
      padding-left: 10px;
      background: #fff;
    }
    select.first {
      width: 310px;
    }
    .left {
      display: inline-block;
      float: left;
      min-width: 116px;
      margin-right: 10px;
      color: $gray-word;
      text-align: right;
    }
  }
}
</style>
